/** Nullable API headers are blank inputs; textual IDs keep their leading zeros. */
export function masterDataFormValue(value: unknown): string {
  return value === undefined || value === null ? '' : String(value);
}
